import React, { useState, useEffect } from 'react';
import WorkInProgress from '../../../components/common/WorkInProgress';
import ProfileBasicInfo from './ProfileBasicInfo';
import DashboardCharts from './DashboardCharts';
import CoursesComponent from './CoursesComponent';
import SalesComponent from './SalesComponent';
import './dashboard.css'
import { getMyProfileData } from '../../../services/Admin/admin';
const AdminProfile = () => {
  const [activeTab, setActiveTab] = useState('courses');

  const [userData,setUserData] = useState()
  const [loading , setLoading] = useState(false)

  const handleUpdateUser = () => {
    // setUserData(prevData => ({
    //   ...prevData,
    //   ...updatedData
    // }));
    fetchData()
  };
    const fetchData = async () => {
      setLoading(true)
    const data = await getMyProfileData(); 
    if (data) {
      console.log("admin profile data >>>", data);
      setUserData(data);
    }
      setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="admin-dashboard" style={{padding:'20px'}}>
      {
        loading ?
         <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        :
        <>
        <ProfileBasicInfo
        userData={userData}
        onUpdateUser={handleUpdateUser}
      />
      <DashboardCharts userData={userData}/>
      <div className="flex space-x-4 mb-6" style={{ display: 'flex', gap: '10px', padding: '20px' }}>
        <button
          onClick={() => setActiveTab('courses')}
          className={`px-6 py-3 rounded-xl shadow-md transition dashboard-btn
            ${activeTab === 'courses'
              ? ' bg-[#f1eff4] text-gray-700'
              : 'bg-white text-black'
            }`}
        >
          Courses
        </button>
        <button
          onClick={() => setActiveTab('sales')}
          className={`px-6 py-3 rounded-xl shadow-md transition  dashboard-btn
            ${activeTab === 'sales'
              ? 'bg-[#f1eff4] text-gray-700'
              : 'bg-white text-black'
            }`}
        >
          Sales
        </button>
      </div>
      {activeTab === 'courses' && <CoursesComponent />}
      {activeTab === 'sales' && <SalesComponent />}
        </>
}
      
    </div>
  );
};

export default AdminProfile;